import z from 'zod'
import {
  firestoreWriteTimestamp,
  nullSafeOptionalFirestoreTimestamp,
  nullSafeOptionalNumber,
  nullSafeOptionalString,
} from '../shared/schema'
import { CollaborationDataType } from './types'

export const schema = z.object({
  questionId: z.string(),
  data: z.record(z.any()).optional(),
  reviewed: z.boolean().optional(),
  userId: nullSafeOptionalString(),
  sourceId: nullSafeOptionalString(),
  collaborationDataType: z.nativeEnum(CollaborationDataType),
  location: z
    .object({
      x: nullSafeOptionalNumber(),
      y: nullSafeOptionalNumber(),
      container: nullSafeOptionalString(),
      order: z.number().optional(),
    })
    .optional(),
  label: nullSafeOptionalString(),
  updatedAt: nullSafeOptionalFirestoreTimestamp(),
})

export const empty = Object.freeze(
  schema.parse({
    questionId: '',
    collaborationDataType: CollaborationDataType.sortableInput,
    location: { x: 0, y: 0 },
    label: '',
  })
)

export const writeSchema = schema.extend({
  updatedAt: firestoreWriteTimestamp,
})

export type FirestoreRoomStateCollaborationData = z.infer<typeof schema>
